import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
//import axios from 'axios';
import { useEffect } from 'react';
const Forget= () => {
   
   /* const [fullName,setFullName] = useState('');
   const [email,setEmail] = useState('');
   const [userPass,setUserPass] = useState('');
   const [role,setRole] =useState('');
   const [errors,setErrors] =useState('');
   const navigate = useNavigate(); // For navigation
   useEffect(() => {
             // Add a class to the body when this component is mounted
             // Remove class from <body> tag
             document.body.classList.remove('register-page');
             // Cleanup function to remove class when the component is unmounted
             return () => {
             // Remove the class on unmount
               document.body.classList.remove('register-page');
             };
           }, []); // Empty dependency array ensures this effect runs only once (on mount)
   const passMatch =(e) => {
    e.preventDefault();
    if(!(userPass===e.target.value)) {
        document.getElementById("conPass").value="";
    }
   }
     const handleRegister =(e) => {
        e.preventDefault(); // Prevent form default behavior
        const formData=new FormData();
        formData.append("jsonData" , JSON.stringify({
            "fullName":fullName,
            "email":email,
            "userPass":userPass,
            "role":role
          }));
        const REST_API_BASE_URL = `http://localhost:8081/api/register`;
      const loginIn= (formData) => axios.post(REST_API_BASE_URL,formData);
      loginIn(formData)
        .then((response) => {
        window.alert(`Success! `+response.data);
          navigate("/login"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          setErrors(error);
          
          
        });
     }
    */
    return (
        
    <div class="container">
      <div class="auth-wrapper">
        <form >

          <div class="auth-box">
            <a href="index-2.html" class="auth-logo mb-4">
              <img src="assets/images/logo.jpg" alt="Webnet logo"/>
            </a>

            <h4 class="mb-4">Reset Password</h4>

            <div class="mb-3">
              <label class="form-label" for="currentPwd">Current password <span class="text-danger">*</span></label>
              <div class="input-group ">
                <input type="password" id="currentPwd" class="form-control" placeholder="Enter current password"/>
                <button class="btn btn-outline-secondary" type="button">
                  <i class="ri-eye-line text-primary"></i>
                </button>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="newPwd">New password <span class="text-danger">*</span></label>
              <div class="input-group ">
                <input type="password" id="newPwd" class="form-control" placeholder="Enter new password"/>
                <button class="btn btn-outline-secondary" type="button">
                  <i class="ri-eye-line text-primary"></i>
                </button>
              </div>
              <div class="form-text">
                Your password must be 8-20 characters long.
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label" for="confNewPwd">Confirm new password <span class="text-danger">*</span></label>
              <div class="input-group ">
                <input type="password" id="confNewPwd" class="form-control" placeholder="Confirm new password"/>
                <button class="btn btn-outline-secondary" type="button">
                  <i class="ri-eye-line text-primary"></i>
                </button>
              </div>
            </div>

            <div class="mb-3 d-grid">
              <button type="submit" class="btn btn-primary">
                Reset Password
              </button>
            </div>

          </div>

        </form>
      </div>
    </div>

    );
}
export default Forget;
